module.exports = __webpack_public_path__ + "assets/img/icon-8.b6b760fe.png";